import { FlowStepData } from "../FlowStepData";
import { MultiExecutableOutputDefinition } from "../../../Common/Execution/MultiExecutable";
import { MappingConfiguration } from "../../../Mapping/MappingConfiguration";
import { DataDefinition } from "../../../Common/Data/DataDefinition";

export class MappingStep extends FlowStepData {
    readonly __type: string = "run_mapping";

    executable: MappingConfiguration = new MappingConfiguration();

    constructor() {
        super();

        this.executable.executionResult = new DataDefinition();

        this.name = "Mapping";
    }

    getOutcomes(): MultiExecutableOutputDefinition[] {
        return [new MultiExecutableOutputDefinition("done", this.executable.getExecutionResult().fields)];
    }
}
